import { authClient, API } from "../index";

/* ---------- Admin ---------- */

// Lista de sesiones (sin content)
export const getSessions = () => {
	return authClient().get(`${API}/session`);
};

// Sesión por id (con content)
export const getSessionById = (id) => {
	return authClient().get(`${API}/session/${id}`);
};

// Snapshot completo (estado en vivo)
export const getSessionState = (id) => {
	return authClient().get(`${API}/session/${id}/state`);
};

// Sesión activa (público)
export const getActiveSession = () => {
	return authClient().get(`${API}/session/active`);
};

// Crear sesión: { name, code, numTables, demo, content?, settings? }
export const postSession = (session) => {
	return authClient().post(`${API}/session`, session);
};

// Actualizar sesión: name, code, numTables, demo, settings, content, contentVersion
export const updateSession = (id, session) => {
	return authClient().put(`${API}/session/${id}`, session);
};

// Eliminar sesión
export const deleteSession = (id) => {
	return authClient().delete(`${API}/session/${id}`);
};

// Activar (desactiva las demás)
export const activateSession = (id) => {
	return authClient().post(`${API}/session/${id}/activate`);
};

// Duplicar (copia demo con el mismo contenido)
export const duplicateSession = (id) => {
	return authClient().post(`${API}/session/${id}/duplicate`);
};

// Recargar contenido desde la semilla del backend
export const reloadSessionContent = (id) => {
	return authClient().post(`${API}/session/${id}/content/reload`);
};

/* ---------- Control (acepta la cookie de admin) ---------- */

export const controlNext = (id) => {
	return authClient().post(`${API}/session/${id}/control/next`);
};

export const controlPrev = (id) => {
	return authClient().post(`${API}/session/${id}/control/prev`);
};

export const controlGoto = (id, phase) => {
	return authClient().post(`${API}/session/${id}/control/goto`, { phase });
};

// { keepTables = true, includeSurvey = false }
export const controlReset = (id, options = {}) => {
	return authClient().post(`${API}/session/${id}/control/reset`, {
		keepTables: true,
		includeSurvey: false,
		...options,
	});
};

// { round, text }
export const controlReminder = (id, body) => {
	return authClient().post(`${API}/session/${id}/control/reminder`, body);
};

// { what: 'auto'|'surprise'|'response'|'all', count? }
export const controlSimulate = (id, body = { what: "auto" }) => {
	return authClient().post(`${API}/session/${id}/control/simulate`, body);
};

export const controlClearSimulated = (id) => {
	return authClient().post(`${API}/session/${id}/control/clear-simulated`);
};

// { kind: 'surprise'|'response', round? }
export const controlReopenTable = (id, tableId, body) => {
	return authClient().post(
		`${API}/session/${id}/control/table/${tableId}/reopen`,
		body
	);
};
